export const getHost = () =>
  process.env.REACT_APP_IS_PRODUCTION === 'true'
    ? window.location.origin
    : 'https://dev.alex-logistic.com'
    // : 'http://127.0.0.1:8000'
